module.exports = __webpack_public_path__ + "media/top/helpful_info_freelance-3c99f5c7.svg";